import React, { useContext } from 'react';
import { Col } from '@thd-olt-component-react/core-ui';
import { PackagesMiniContext } from '../PackagesMiniContext';
import {
  getPackageTitle,
  getPackageUrl
} from '../../utils';
import { VisualProductImages } from './VisualProductImages';
import './visual-package-info.scss';

const VisualPackageInfo = () => {
  const { packageModel, products } = useContext(PackagesMiniContext);
  const packageTitle = getPackageTitle(packageModel);
  const packageUrl = getPackageUrl(packageModel);

  return (
    <>
      <Col className="visual-package-info__title-container">
        <h2 className="visual-package-info__title">
          {packageTitle}
        </h2>
      </Col>
      <Col className="visual-package-info__mobile-images-container" flatten>
        <VisualProductImages />
      </Col>
    </>
  );
};

VisualPackageInfo.displayName = 'VisualPackageInfo';

export { VisualPackageInfo };